var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notications"},[(_vm.showAlert)?_c('v-alert',{attrs:{"type":_vm.alertType,"dismissible":""},on:{"input":function($event){_vm.showAlert = false}}},[_vm._v(" "+_vm._s(_vm.getTranslatedText(_vm.alertText))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }